<template>
  <HeaderPages />
  <section class="section_header_full_pages">
    <div class="waves_full_pages"></div>
    <div class="box_img_brand_project">
      <img
        src="@/assets/project/Onegin/Onegin.png"
        class="img_brand_project"
        alt="логтип Onegin"
      />
    </div>
    <div class="container_text_full_pages">
      <h1 class="title_home">
        <span class="title_home_4"
          >Сайт для продажи<br />
          коттеджей
        </span>
      </h1>
      <div class="box_button_brifing_full_pages">
        <div class="box_button_v2">
          <button class="button_v1" data-action="toggleBig">
            Оставить заявку
          </button>
        </div>
      </div>
    </div>
  </section>
  <section class="section_main_info_project">
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="font_2_4_700_Kreadon">2024</p>
      </div>
      <div class="box_main_info_project_right">
        <p class="font_2_4_700_Kreadon">Онегин 55</p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">
          UX/UI дизайн <BR />
          &nbsp;
          <BR />
          Backend <BR />
          &nbsp;
          <BR />
          Frontend
          <BR />
          &nbsp;
          <BR />
          DevOps
          <BR />
          &nbsp;
          <BR />
          Настройка контекстной рекламы
        </p>
      </div>
      <div class="box_main_info_project_right">
        <p class="subtext_services_design">
          Коттеджи «Пушкино» – коттеджный поселок, предлагающий комфортабельные
          загородные дома с удобной инфраструктурой и выгодными условиями
          покупки
        </p>
      </div>
    </div>
    <!-- <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <a target="_blank" href="https://yycare.life/" class="button_light"
          >Сайт</a
        >
      </div>
    </div> -->
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Цели</p>
      </div>
      <div class="box_main_info_project_right">
        <p class="subtext_services_design">
          Разработать удобный и продающий сайт, который позволит потенциальным
          покупателям легко выбрать и забронировать коттедж, а застройщику
          оперативно получать заявки в Telegram.
        </p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Задачи</p>
      </div>
      <div class="box_main_info_project_right">
        <ul class="list_articles subtext_services_design">
          <li>Разработать удобный каталог коттеджей</li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Визуализировать преимущества поселка с помощью качественного дизайна
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>Создать простую и удобную систему оформления заявок</li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>Интегрировать отправку заявок напрямую в Telegram застройщика</li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>Настроить контекстную рекламу для привлечения клиентов</li>
        </ul>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Решение</p>
      </div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">01</p>
          <p class="subtext_services_design">
            <span class="fatty_font">Современный UX/UI-дизайн</span>
            <BR />
            &nbsp;
            <BR />
            Мы разработали минималистичный и удобный интерфейс, который помогает
            пользователям быстро находить нужную информацию о коттеджах и
            поселке.
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">02</p>
          <p class="subtext_services_design">
            <span class="fatty_font">Вариативный каталог коттеджей</span>
            <BR />
            &nbsp;
            <BR />
            На сайте реализован интерактивный каталог домов, где можно
            фильтровать объекты по площади, количеству комнат, стоимости и
            другим характеристикам.
          </p>
        </div>
      </div>
    </div>
    <div class="container_slaider_project">
      <button class="custom-prev">
        <img
          class="arrow_left_slider"
          src="@/assets/elements/arrow_right.svg"
          alt="стрелка"
        />
      </button>

      <button class="custom-next">
        <img
          class="arrow_right_slider"
          src="@/assets/elements/arrow_right.svg"
          alt="стрелка"
        />
      </button>
      <swiper
        :modules="modules"
        :slides-per-view="1"
        loop="true"
        class="mySwiper"
        :navigation="{
          nextEl: '.custom-next',
          prevEl: '.custom-prev',
        }"
      >
        <swiper-slide v-for="(slide, index) in slides" :key="index">
          <img :src="slide" class="slide-content" alt="Слайд проекта" />
        </swiper-slide>
      </swiper>
    </div>

    <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">03</p>
          <p class="subtext_services_design">
            <span class="fatty_font">Упрощенная система заявок</span>
            <BR />
            &nbsp;
            <BR />
            Форма отправки заявок позволяет клиентам быстро оставить контактные
            данные. Заявки автоматически передаются застройщику в Telegram, что
            ускоряет процесс коммуникации.
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">04</p>
          <p class="subtext_services_design">
            <span class="fatty_font">Настройка контекстной рекламы</span> <BR />
            &nbsp;
            <BR />
            Для привлечения потенциальных покупателей настроены рекламные
            кампании в Яндекс.Директ, ориентированные на целевую аудиторию,
            интересующуюся покупкой загородной недвижимости.
          </p>
        </div>
      </div>
    </div>

    <swiper
      :modules="modules"
      :slides-per-view="slidesPerView"
      loop="true"
      class="mySwiper_2"
    >
      <swiper-slide v-for="(slides_2, index) in slides_2" :key="index">
        <img :src="slides_2" class="simg_project" alt="Слайд проекта" />
      </swiper-slide>
    </swiper>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Результат</p>
      </div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Простой и удобный сайт с адаптивным дизайном
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Каталог недвижимости с фильтрацией и детальной информацией
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Моментальное получение заявок через Telegram
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Настроенная контекстная реклама для эффективного привлечения
            клиентов
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="container_main_info_project">
        <div class="box_main_info_project_left"></div>
        <div class="box_main_info_project_right">
          <div class="flex_space_between">
            <p class="subtext_services_design">
              <span class="font_2_4_700_Kreadon color_violet">10000</span>
              <BR />
              Рейтинги
            </p>
            <p class="subtext_services_design">
              <span class="font_2_4_700_Kreadon color_violet">10000</span>
              <BR />
              Рейтинги
            </p>
          </div>
        </div>
      </div> -->
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Команда</p>
      </div>
      <div class="box_main_info_project_right_row">
        <ul class="ul_team subtext_services_design">
          <span class="color_violet">Команда</span>
          <li>UX/UI дизайн: Стрельцова Валерия</li>
          <li>Frontend-разработка: Немчицкий Кирилл</li>
          <li>Backend и DevOps: Кошелев Ростислав</li>
        </ul>
      </div>
    </div>
  </section>
  <SectionBlog />
  <SectionProjects />
  <FooterPages />
</template>
<script>
import { useHead } from "@vueuse/head";
import { ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import HeaderPages from "../permanent/HeaderPages.vue";
import FooterPages from "../permanent/FooterPages.vue";
import SectionBlog from "../ui/SectionBlog.vue";
import SectionProjects from "../ui/SectionProjects.vue";
import slide_1 from "@/assets/project/Onegin/Onegin_slide_1.webp";
import slide_2 from "@/assets/project/Onegin/Onegin_slide_2.webp";
import slide_3 from "@/assets/project/Onegin/Onegin_slide_3.webp";
import slide_4 from "@/assets/project/Onegin/Onegin_slide_4.webp";

import slide_1_m from "@/assets/project/Onegin/Onegin_slide_1_m.webp";
import slide_2_m from "@/assets/project/Onegin/Onegin_slide_2_m.webp";
import slide_3_m from "@/assets/project/Onegin/Onegin_slide_3_m.webp";
import slide_4_m from "@/assets/project/Onegin/Onegin_slide_4_m.webp";

export default {
  components: {
    Swiper,
    SwiperSlide,
    HeaderPages,
    FooterPages,
    SectionBlog,
    SectionProjects,
  },

  setup() {
    useHead({
      title:
        "Сайт для продажи коттеджей «Онегин 55» – Разработка, UX/UI-дизайн, каталог недвижимости",
      meta: [
        {
          name: "description",
          content:
            "Разработка сайта для продажи коттеджей «Онегин 55» – удобный каталог недвижимости, система онлайн-заявок с интеграцией в Telegram, UX/UI-дизайн, настройка контекстной рекламы. Узнайте, как мы создали эффективную платформу для застройщика.",
        },
      ],
    });
    const slides = [slide_1, slide_2, slide_3, slide_4];
    const slides_2 = [slide_1_m, slide_2_m, slide_3_m, slide_4_m];

    const slidesPerView = ref(3);

    const updateSlidesPerView = () => {
      if (window.innerWidth <= 767) {
        slidesPerView.value = 2;
      } else {
        slidesPerView.value = 3;
      }
    };
    onMounted(() => {
      updateSlidesPerView();
      window.addEventListener("resize", updateSlidesPerView);
    });
    return {
      slides,
      slides_2,
      updateSlidesPerView,
      slidesPerView,
      modules: [Navigation],
    };
  },
};
</script>
<style scoped>
.container_main_info_project {
  height: fit-content;
}
.section_main_info_project {
  gap: 2.5rem;
}

.section_header_full_pages {
  background: linear-gradient(
    -23.36deg,
    rgb(238, 238, 235) 20.04%,
    rgb(207, 197, 196) 97.438%
  );
}
.img_brand_project {
  width: 22.85rem;
  height: 15.85rem;
}
.box_img_brand_project {
  position: absolute;
  right: 4.5rem;
  top: 9rem;
}
.simg_project {
  height: 37rem;
  border-radius: 1.7rem;
  box-shadow: 0.7rem 0.7rem 2rem -0.8rem rgba(71, 86, 163, 0.4);
  background: rgb(245, 247, 255);
}
.fatty_font {
  font-family: Kreadon-Bold !important;
}
.mySwiper_2 {
  padding-bottom: 4rem;
}
@media (max-width: 767px) {
  .container_text_full_pages {
    padding: 11rem 2rem 4.5rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .section_header_full_pages {
    height: 51.36rem;
    overflow: hidden;
  }
  .title_home {
    z-index: 0;
  }
  .img_brand_project {
    width: 34.91rem;
    height: 24.18rem;
  }
  .box_img_brand_project {
    position: absolute;
    right: -7rem;
    top: 16rem;
  }
  .simg_project {
    height: 28rem;
    box-shadow: 1.27rem 1.27rem 3.64rem -1.45rem rgba(71, 86, 163, 0.4);
  }
  .mySwiper_2 {
    padding-left: 1.5rem;
    padding-bottom: 4rem;
  }
  .container_main_info_project {
    flex-direction: column;
  }
  .ul_team .color_violet {
    display: none;
  }
  .font_1_400_Kreadon_Regular {
    line-height: 1.27rem;
  }
  .container_slaider_project {
    margin: 0rem;
  }
}
</style>
